import React from 'react'
import { Button } from '../Button'
import { Select } from '../Forms'
import {
  Flex,
  HStack,
  Spacer,
  StackProps,
  VisuallyHidden,
} from '@chakra-ui/react'
import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaChevronLeft,
  FaChevronRight,
} from 'react-icons/fa'

interface PaginationToolbarProps extends StackProps {
  numberOfPages: number
  pageIndex: number
  setPageIndex: (index: number) => void
  recordsPerPage: number[]
  onRecordsPerPageChange: (recordsPerPage: number) => void
}

const PaginationToolbar = ({
  numberOfPages,
  pageIndex,
  setPageIndex,
  recordsPerPage,
  onRecordsPerPageChange,
  ...baseProps
}: PaginationToolbarProps) => {
  const recordsPerPageOptions: {
    value: number
    label: string
  }[] = recordsPerPage.map(numberPerPage => ({
    value: numberPerPage,
    label: numberPerPage.toLocaleString(),
  }))
  return (
    <Flex {...baseProps} grow={1}>
      <HStack justify="center">
        <Button
          variant="link"
          disabled={pageIndex <= 0}
          onClick={() => setPageIndex(0)}
        >
          <VisuallyHidden>Go To First Page</VisuallyHidden>
          <FaAngleDoubleLeft aria-hidden />
        </Button>
        <Button
          variant="link"
          disabled={pageIndex <= 0}
          onClick={() => setPageIndex(Math.max(pageIndex - 1, 0))}
        >
          <VisuallyHidden>Go To Previous Page</VisuallyHidden>
          <FaChevronLeft aria-hidden />
        </Button>
        <span>
          <VisuallyHidden>Viewing</VisuallyHidden> Page {pageIndex + 1} of{' '}
          {numberOfPages}
        </span>
        <Button
          variant="link"
          disabled={pageIndex >= numberOfPages - 1}
          onClick={() =>
            setPageIndex(Math.min(pageIndex + 1, Math.max(pageIndex + 1, 0)))
          }
        >
          <VisuallyHidden>Go To Next Page</VisuallyHidden>
          <FaChevronRight aria-hidden />
        </Button>
        <Button
          variant="link"
          disabled={pageIndex >= numberOfPages - 1}
          onClick={() => setPageIndex(numberOfPages - 1)}
        >
          <VisuallyHidden>Go To Last Page</VisuallyHidden>
          <FaAngleDoubleRight aria-hidden />
        </Button>
      </HStack>
      <Spacer />
      <HStack spacing="0.5rem">
        <span>Display</span>
        <Select
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            onRecordsPerPageChange(Number(e.target.value))
          }
          size="sm"
          width="5.5rem"
        >
          {recordsPerPageOptions.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </Select>
        <span>per page</span>
      </HStack>
    </Flex>
  )
}

export default PaginationToolbar
